import React, {useState, useEffect, useRef } from "react";
import {Button, Modal, Layout, Table, Icon, Input} from "antd";
import _ from "i18n";
import {connect} from "react-redux";
import {getUnpaidInvoicesDetails, getDocumentsToBeExportedZipEfff, startCommandExportEfffZip, getCommandInfo} from "../../../actions/thunks.js";
import {setFiltredDocumentsToBeExportedEfffZip} from "../../../actions/actions.js";
import {formatAmount} from "utils";
import moment from "moment";
import {FileZipOutlined} from '@ant-design/icons';
import SidePageHeaderPopPup from "../../common/SidePageHeaderPopUp";
import {formatPhoneNumber} from "../../../services/utils";

const { Search } = Input;

const DocumentsToBeExportedEfffZipDetails = ({statisticsFilter,
  documentsToBeExportedEfffZip,
  auth,
  appRef,
  discriminant,
  textPopup,
  operationType,
  getUnpaidInvoicesDetails,
  setFiltredDocumentsToBeExportedEfffZip,
  getDocumentsToBeExportedZipEfff,
  startCommandExportEfffZip,
  getCommandInfo}) => {

  const [search, setSearch] = useState('');
  const [showSpinner, setShowSpinner] = useState(false);

  
  const commandTimer = useRef(null);
  const currRequestId = useRef(null);

  const columns = [
      {
        title: _("credit-note-number"),
        dataIndex: "officialNumber",
        align: "left",
        width:91
      },
      {
        title: _("Date"),
        dataIndex: "documentDate",
        align: "left",
        width:74,
        render: date => moment(date).format("DD/MM/YYYY")
      },

      {
        title: _("vcs"),
        dataIndex: "vcs",
        align: "left",
        width:101,

      },


      {
        title: _("user-email"),
        align: "left",
        dataIndex: "user.mainEmail",
        width:235,

      },

      {
        title: _("user-phone"),
        align: "left",
        dataIndex: "user.mainPhone",
        width:105,
        render: phone => formatPhoneNumber(phone)

      },

      {
        title: _("organization"),
        dataIndex: "clientOrganization",
        align: "left",
        width:125,

      },


      {
        title: _("comment"),
        dataIndex: "comment",
        align: "left",
        width:259,

      },


      {
        title: _("To"),
        align: "center",
        dataIndex: "issuer.abbreviation",
        width:81,

      },


      {
        title: _("amount"),
        dataIndex: "includingVatAmount",
        align: "center",
        width:56,

        render: amount => formatAmount(amount)
      },

      {
        title: _("Status"),
        align: "center",
        dataIndex: "status",
        width:45,
        render: (text, record) => _(record.status)

      },

    ];

   const loadDocuments = () => {
    getDocumentsToBeExportedZipEfff(
      statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [],
      statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [],
      auth.currentClient ? auth.currentClient.id : null,
      statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [],
      discriminant ? discriminant : null,
      statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType : []
    );
  };

  useEffect(() => {
    if (statisticsFilter.apps && statisticsFilter.apps.length > 0) {
      loadDocuments();
    }
  }, []);


   useEffect(() => {
    return () => {
      clearInterval(commandTimer.current);
    };
  }, []);

  useEffect(() => {
  if (discriminant !== null && operationType !== null) {
    loadDocuments();
  }
}, [discriminant]);

  const calculSum = () => {
    return (documentsToBeExportedEfffZip.filteredItems || []).reduce((sum, { includingVatAmount , manual }) => {
        sum += parseInt(includingVatAmount);
        if (manual && manual.amount) {
          sum -= parseInt(manual.amount);
        }
        return sum
      }, 0
    );
  };


  const handleSearch = (value) => {
    setSearch(value);

    let results=(documentsToBeExportedEfffZip.items || []).filter((elem)=>{

      return (contains(elem.user.mainEmail,value.trim()) || contains(elem.vcs,value.trim()) || contains(elem.clientOrganization,value.trim()) || contains(elem.comment,value.trim()))
    });
    setFiltredDocumentsToBeExportedEfffZip(results);

  };

  const contains = (name, text) => {
    if(name === null ) return;
    return (name.trim()).search(new RegExp(text, 'gi')) !== -1 || (name.trim()).search(new RegExp(text, 'gi')) === 0;
  };

  const getEfffZip = () => {
    const popup = window.open(
      "",
      "_self",
    );
    setShowSpinner(true);
    startCommandExportEfffZip(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [] , statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], discriminant ? discriminant : null, "efff").then((res) => {
      // Clear previous timer
      // Clear previous timer
      clearInterval(commandTimer.current);

      const startCommandTimer = () => {
        // Pour éviter des requête concurrentes
        currRequestId.current = `COMMAND_REQUEST_${performance.now()}`;
        let prevRequestId = currRequestId.current;

        getCommandInfo(res.value.data.data.command.id)
          .then((resultat) => {
            if (prevRequestId !== currRequestId.current) {
              return;
            }

            if (resultat.data.data.status !== "FINISHED") {
              setShowSpinner(true);
              return;
            }

            // Arréter le timer
            clearInterval(commandTimer);
            setShowSpinner(false);
            popup.location.href = resultat.data.data.result;

          })
          .catch(() => {
            clearInterval(commandTimer.current);
          });
      }

      commandTimer.current = setInterval(startCommandTimer, 3 * 1000);
    })
  }

  const getPdfZip = () => {

    const popup = window.open(
      "",
      "_self",
    );
    setShowSpinner(true);
    startCommandExportEfffZip(statisticsFilter.apps && statisticsFilter.apps.length > 0 ? statisticsFilter.apps : [] , statisticsFilter.appRefs && statisticsFilter.appRefs.length > 0 ? statisticsFilter.appRefs : [], auth.currentClient ? auth.currentClient.id : null, statisticsFilter.year && statisticsFilter.year.length > 0 ? statisticsFilter.year : [], discriminant ? discriminant : null, "pdf", statisticsFilter.appType && statisticsFilter.appType.length > 0 ? statisticsFilter.appType[0] : []).then((res) => {
      // Clear previous timer
      // Clear previous timer
      clearInterval(commandTimer);

      const startCommandTimer = () => {
        // Pour éviter des requête concurrentes
        currRequestId.current = `COMMAND_REQUEST_${performance.now()}`;
        let prevRequestId = currRequestId.current;

        getCommandInfo(res.value.data.data.command.id)
          .then((resultat) => {
            if (prevRequestId !== currRequestId.current) {
              return;
            }

            if (resultat.data.data.status !== "FINISHED") {
              setShowSpinner(true);
              return;
            }

            // Arréter le timer
            clearInterval(commandTimer);
            setShowSpinner(false);
            popup.location.href = resultat.data.data.result;

          })
          .catch(() => {
            clearInterval(commandTimer);
          });
      }

      commandTimer.current = setInterval(startCommandTimer, 3 * 1000);
    })
  }

    const organization = auth.currentClient ? (auth.currentClient.abbreviation ? auth.currentClient.abbreviation : auth.currentClient.name) : "";
    return (
      <div className="stats-invoice-detail ">

        <div className="bg-blue-lightest h-16 modal-header-title">
          <SidePageHeaderPopPup subHeader={_("stats")}  organization = {organization}  appRefs = {statisticsFilter.appRefs} appRefsStore = {appRef}/>
        </div>

        <div className="flex flex-row justify-between mt-8" >

          <div className="flex items-center justify-start">
            <div className="recap-day-title">
              {textPopup}

            </div>

            <div className="ml-2" onClick={getEfffZip} style={{cursor: 'pointer'}}>
              <FileZipOutlined style={{ fontSize: '20px', color: '#2495e1' }} />
            </div>
            <div className="ml-2" style={{cursor: 'pointer'}} onClick={getPdfZip}>
              <Icon type="file-pdf" style={{ fontSize: '20px', color: '#2495e1' }} />
            </div>

          </div>
          <div className="w-1/3">
            <Search
              placeholder="input search text"
              onChange={({target: {value}}) => handleSearch(value)}
              size={"small"}
              allowClear={true}
              value={search.trim()}
            />

          </div>
        </div>

        <div className="pt-4  pb-8 relative">

          <Table
            rowKey="id"
            columns={columns}
            dataSource={documentsToBeExportedEfffZip.filteredItems.length > 0 ? documentsToBeExportedEfffZip.filteredItems : null}
            loading={documentsToBeExportedEfffZip.fetching}
            pagination={false}
            size="middle"
            className="ttp-invoice-detail-tab table-padding"
            scroll={{ x:false, y: 400 }}
          />

          {showSpinner ? <div className="div-fetching-file flex items-center justify-center ">

            <Icon type="sync" spin style={{ fontSize: '50px'}} />

          </div> : null
          }

        </div>

        <div className="flex flex-row justify-between pt-4  self-end pb-8">
          <div className="pr-4 border-right-line"> TOTAL</div>
          <div className="div-recap-amount-total"> { formatAmount(calculSum()) } </div>
        </div>
      </div>
    );
}

const mapStateToProps = state => ({
  statisticsFilter: state.filters.statisticsFilter,
  documentsToBeExportedEfffZip: state.documentsToBeExportedEfffZip,
  auth: state.auth,
  appRef: state.appRefFilter.items,

});

const mapDispatchToProps = {
  getUnpaidInvoicesDetails,
  setFiltredDocumentsToBeExportedEfffZip,
  getDocumentsToBeExportedZipEfff,
  startCommandExportEfffZip,
  getCommandInfo
};

export default connect(mapStateToProps, mapDispatchToProps)(DocumentsToBeExportedEfffZipDetails);



// WEBPACK FOOTER //
// ./app/components/Admin/statisctics/DocumentsToBeExportedEfffZipDetails.js